import {
  PatientInsurance,
  PatientInsuranceControllerApi,
} from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 *
 * @author Atish Bagate
 */

interface Params {
  patientInsurance: PatientInsurance;
  xTENANTID?: string;
}

export const useUpdatePatientInsurance = () =>
  useMutationWithLoading(async (params: Params) =>
    new PatientInsuranceControllerApi(getConfigObject()).updatePatientInsurance(
      params.patientInsurance,
      params.xTENANTID
    )
  );
